import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { PrintingSection } from '../../../features/settings/printing-section'

export const Route = createFileRoute('/_app/settings/printing')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'printing'),
  component: PrintingSection,
})
